import { useMutation } from '@tanstack/react-query';

import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type {
  CheckDuplicateClientsPayload,
  CheckDuplicateClientsResponse,
} from '@/types/clientsApiTypes';

export const useCheckDuplicateClientsMutation = () => {
  const { doFetch } = useFetch<CheckDuplicateClientsPayload, CheckDuplicateClientsResponse>();

  return useMutation<CheckDuplicateClientsResponse, ErrorResponse<unknown>, CheckDuplicateClientsPayload>({
    mutationFn: (payload) =>
      doFetch('/api/clients/duplicate-check', {
        method: 'POST',
        body: payload,
      }),
  });
};
